/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BulkValuationListItemDto } from '../model/bulkValuationListItemDto';
import { BulkValuationResultDto } from '../model/bulkValuationResultDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BulkValuationViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * AmsAction:GET/api/BulkValuationView AmsResource:{country}/{business}/_* 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBulkValuations(observe?: 'body', reportProgress?: boolean): Observable<Array<BulkValuationListItemDto>>;
    public getBulkValuations(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BulkValuationListItemDto>>>;
    public getBulkValuations(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BulkValuationListItemDto>>>;
    public getBulkValuations(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BulkValuationListItemDto>>(`${this.basePath}/api/BulkValuationView`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BulkValuationView/result/{bulkValuationId} AmsResource:{country}/{business}/_* 
     * @param bulkValuationId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBulkValuationsResult(bulkValuationId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BulkValuationResultDto>>;
    public getBulkValuationsResult(bulkValuationId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BulkValuationResultDto>>>;
    public getBulkValuationsResult(bulkValuationId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BulkValuationResultDto>>>;
    public getBulkValuationsResult(bulkValuationId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (bulkValuationId === null || bulkValuationId === undefined) {
            throw new Error('Required parameter bulkValuationId was null or undefined when calling getBulkValuationsResult.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BulkValuationResultDto>>(`${this.basePath}/api/BulkValuationView/result/${encodeURIComponent(String(bulkValuationId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
